import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const BannerLink = styled(Link)`
    text-decoration: none;
    display: ${({hidebanner}) => hidebanner ? 'none':'block'};
    margin: 10px 0 8px;

    @media screen and (max-width: 767px) {
        margin: 0;
    }
`
export const BannerImage = styled.img`
    width: 100%;
    object-fit: cover;

`